import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { WcGridModule } from '../../components/wc-grid/wc-grid.module';

@Component({
  selector: 'app-models-table-detail',
  standalone: true,
  templateUrl: './models-table-detail.component.html',
  styleUrls: ['./models-table-detail.component.css'],
  imports: [CommonModule, MatButtonModule, WcGridModule],
})
export class ModelsTableDetailComponent implements OnChanges {
  @Input() schemaId!: string;
  @Input() tableId!: string;
  @Input() tableName!: string;
  @Output() back = new EventEmitter<void>();

  gridContext: Record<string, any> = {};

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['schemaId'] || changes['tableId']) && this.schemaId && this.tableId) {
      this.gridContext = { schemaId: this.schemaId, tableId: this.tableId };
    }
  }
}
